export default "__VITE_ASSET__DsyL$OKz__"